// Selection is not activation. Never infer money-movement readiness from this value.
export const ACTIVE_CARD_PROVIDER = 'kemycard';
export const KEMYCARD_LAUNCH = {
    provider: ACTIVE_CARD_PROVIDER,
    plan: 'decouverte',
    stage: 'integration',
    moneyMovementEnabled: false,
    legacyProviderEnabled: false,
    customerCryptoDepositsEnabled: false,
    cryptoWithdrawalsEnabled: false,
    acquiringEnabled: false,
    giftCardsEnabled: false,
    virtualAccountsEnabled: false,
};
